import React from "react"
import {CircularProgress} from "@mui/material"
import {formatTextTestIds} from "@next/utils"
import BurgerSecondayNavSection from "../../../BurgerSecondaryNavSection"
import {Column as ColumnModel, Content, Mission as MissionModel} from "../../../../models/secondary-nav"
import {BurgerSecondaryNavDivider} from "../../../BurgerSecondaryNavSection/component"
import {
    BurgerSecondaryNavBackButton,
    BurgerSecondaryNavBackChevron,
    BurgerSecondaryNavContainer,
    BurgerSecondaryNavSectionTitle,
    BurgerSecondaryNavTitleBar,
    BugerSecondaryNavLoadingContainer,
    MissionsContainer,
    BurgerBodyContainer,
} from "./component"
import Missions from "../../../Missions"
import ChipsContainer from "../../../ChipsContainer"

export type SecondaryNavContentProps = {
    columns: ColumnModel[]
    department: string
    englishDepartment: string | null | undefined
    isInSecondaryNav: boolean
    deactivateIndex: () => void
    chevronIcon: string
    text: {arrowIconUrlAltText: string}
    showSecondaryNav: boolean
    hasMissions: boolean
    missions: MissionModel | null
    personalisationContent: Content[] | null
    siteUrl: string
}

export const BurgerSecondaryNav = ({
    columns,
    department,
    englishDepartment,
    isInSecondaryNav,
    deactivateIndex,
    chevronIcon,
    text,
    showSecondaryNav,
    hasMissions,
    missions,
    personalisationContent,
    siteUrl,
}: SecondaryNavContentProps) => {
    let isFirstSection = true
    return (
        <BurgerSecondaryNavContainer
            isInSecondaryNav={isInSecondaryNav}
            showSecondaryNav={showSecondaryNav}
            data-testid={formatTextTestIds(`header-burger-menu-secondary-${department}`)}
        >
            <BurgerSecondaryNavTitleBar>
                <BurgerSecondaryNavBackButton
                    data-testid="header-burger-menu-secondary-nav-back-button"
                    onClick={deactivateIndex}
                    disableRipple
                >
                    <BurgerSecondaryNavBackChevron src={chevronIcon} alt={text.arrowIconUrlAltText} />
                </BurgerSecondaryNavBackButton>
                <BurgerSecondaryNavSectionTitle variant="subtitle2">
                    {department?.replace(/^./, str => str.toUpperCase())}
                </BurgerSecondaryNavSectionTitle>
            </BurgerSecondaryNavTitleBar>
            {personalisationContent && (
                <>
                    <BurgerSecondaryNavDivider />
                    <ChipsContainer personalisationContent={personalisationContent} siteUrl={siteUrl} />
                </>
            )}
            <BurgerSecondaryNavDivider />
            <BurgerBodyContainer>
                {columns.length === 0 && (
                    <BugerSecondaryNavLoadingContainer>
                        <CircularProgress thickness={2} />
                    </BugerSecondaryNavLoadingContainer>
                )}
                {columns.map(({items}, columnIndex) =>
                    items.map((item, itemIndex) => {
                        // we done truly know the first section until we render the first item
                        // we could add a .find to find the first item but that would be an extra loop
                        const localIsFirstSection = isFirstSection
                        isFirstSection = false
                        return (
                            <BurgerSecondayNavSection
                                key={`burger-secondary-section-${columnIndex}-${itemIndex}`}
                                title={item.title}
                                englishTitle={item.englishTitle}
                                department={department}
                                englishDepartment={englishDepartment}
                                blockLinks={item.items}
                                icons={item.icons}
                                isFirstSection={localIsFirstSection}
                            />
                        )
                    }),
                )}
                {hasMissions && (
                    <MissionsContainer data-testid="header-burger-menu-missions">
                        <Missions department={department} data={missions} />
                    </MissionsContainer>
                )}
            </BurgerBodyContainer>
        </BurgerSecondaryNavContainer>
    )
}

export default BurgerSecondaryNav
